import { createContext } from 'react';

import type { Actions, SelectConfigs } from './hooks/useEditOrderLogic';
import type { State } from './types';

type EditOrderContextValue = State & Actions & { select: SelectConfigs };
const EditOrderContext = createContext<EditOrderContextValue | undefined>(undefined);

export default EditOrderContext;
